import api from '../api/axios';

const getList = (skip = 0, take = 25, query = '', status = '', type = '', priority = '') => {
  let url = `/fix-request?skip=${skip}&take=${take}&sort=createdAt%2Cdesc`;
  if (query) url += `&query=${encodeURIComponent(query)}`;
  if (status) url += `&status=${encodeURIComponent(status)}`;
  if (type) url += `&type=${encodeURIComponent(type)}`;
  if (priority) url += `&priority=${encodeURIComponent(priority)}`;
  return api.get(url);
};

const getById = (id) => {
  return api.get(`/fix-request/${id}`);
};

const create = (data) => {
  return api.post('/fix-request', data);
};

const sendToWaitList = (proposalId, data = {}) => {
  return api.post(`/fix-request/send-to-wait-list/${proposalId}`, data);
};

const update = (id, data) => {
  return api.patch(`/fix-request/${id}`, data);
};

const schedule = (id, data) => {
  return api.patch(`/fix-request/${id}/schedule`, data);
};

const changeStatus = (id, status) => {
  return api.patch(`/fix-request/${id}/status`, { status });
};

const resolve = (id, resolutionNotes) => {
  return api.patch(`/fix-request/${id}/resolve`, { resolutionNotes });
};

const remove = (id) => {
  return api.delete(`/fix-request/${id}`);
};

const getByProposal = (proposalId) => {
  return api.get(`/fix-request/by-proposal/${proposalId}`);
};

const getActiveCount = () => {
  return api.get('/fix-request/active-count');
};

const fixRequestServices = {
  getList,
  getById,
  create,
  sendToWaitList,
  update,
  schedule,
  changeStatus,
  resolve,
  remove,
  getByProposal,
  getActiveCount,
};

export default fixRequestServices;
